import PropTypes from 'prop-types';
import queryString from 'querystring';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Field, reduxForm } from 'redux-form';
import Button from '../../components/elements/Button';
import Select from '../../components/fields/Select';
import Text from '../../components/fields/Text';
import {
  fetchCities,
  fetchProvinces,
  fetchRegionals,
  fetchDistricts,
  fetchVillages,
} from '../../components/layouts/PageBase/actions';
import { validate } from './constants';
import styles from './styles.scoped.css';
import { SimpleGrid } from '@mantine/core';

export function Component(props) {
  const { handleSubmit, submitting, change, invalid } = props;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { dataDetailUser, dataRegionals, dataProvinces, dataCities, dataDistricts, dataVillages } =
    useSelector((s) => s.pageBase);
  const {
    region: queryRegion,
    provinceId: queryProvince,
    cityId: queryCity,
    districtId: queryDistrict,
    villageId: queryVillage,
    maxPrice: queryMax,
    minPrice: queryMin,
  } = queryString.parse(location.search.replace('?', ''));
  const [region, setRegion] = useState(queryRegion ?? dataDetailUser?.regionalId);
  const [provinceId, setProvinceId] = useState(queryProvince ?? '');
  const [cityId, setCityId] = useState(queryCity ?? '');
  const [districtId, setDistrictId] = useState(queryDistrict ?? '');
  const [villageId, setVillageId] = useState(queryVillage ?? '');

  const hargaJualMin = {
    placeholder: 'Harga Jual Minimum Per Tabung',
    label: 'Harga Jual Minimum Per Tabung',
    icon: '',
    // value: queryRegion ? dataProducts[0].productMinPrice : 0
  };

  const hargaJualMax = {
    placeholder: 'Harga Jual Maksimum Per Tabung',
    label: 'Harga Jual Maksimum Per Tabung',
    icon: '',
    // value: queryRegion ? dataProducts[0].productMaxPrice : 0
  };

  const getAreaByQuery = (data, query) => {
    return data.filter((p) => p.value === query);
  };

  const onRegionChanged = (value = '') => {
    setRegion(value);
    change('region', value);
    dispatch(fetchProvinces({ regional: JSON.stringify([value]) }));
    dispatch(fetchCities({ regional: JSON.stringify([value]) }));
    dispatch(fetchDistricts({ regional: JSON.stringify([value]) }));
    dispatch(fetchVillages({ regional: JSON.stringify([value]) }));
    // onProvinceChanged();
  };

  const onProvinceChanged = (value = '') => {
    setProvinceId(value);
    change('provinceId', value);
    dispatch(fetchCities({ provinceId: JSON.stringify([value]) }));
    dispatch(fetchDistricts({ provinceId: JSON.stringify([value]) }));
    dispatch(fetchVillages({ provinceId: JSON.stringify([value]) }));
  };

  const onCityChanged = (value = '') => {
    setCityId(value);
    change('cityId', value);
    dispatch(fetchDistricts({ cityId: JSON.stringify([value]) }));
    dispatch(fetchVillages({ cityId: JSON.stringify([value]) }));
  };

  const onDistrictChanged = (value = '') => {
    setDistrictId(value);
    change('districtId', value);
    onVillageChanged();
    dispatch(fetchVillages({ districtId: JSON.stringify([value]) }));
  };

  const onVillageChanged = (value = '') => {
    setVillageId(value);
    change('villageId', value);
  };

  useEffect(() => {
    dispatch(fetchRegionals());
    dispatch(fetchProvinces({ regional: JSON.stringify([region]) }));
    dispatch(
      fetchCities({
        regional: JSON.stringify([region]),
        provinceId: JSON.stringify([provinceId]),
      })
    );
    dispatch(
      fetchDistricts({
        regional: JSON.stringify([region]),
        provinceId: JSON.stringify([provinceId]),
        cityId: JSON.stringify([cityId]),
      })
    );
    dispatch(
      fetchVillages({
        regional: JSON.stringify([region]),
        provinceId: JSON.stringify([provinceId]),
        cityId: JSON.stringify([cityId]),
        districtId: JSON.stringify([districtId]),
      })
    );
  }, []);

  useEffect(() => {
    change('region', queryRegion || region || '');
    change('provinceId', queryProvince || provinceId || '');
    change('cityId', queryCity || cityId || '');
    change('districtId', queryDistrict || districtId || '');
    change('villageId', queryVillage || villageId || '');
    change('hargaJualMin', queryMin);
    change('hargaJualMax', queryMax);
  }, []);

  return (
    <form onSubmit={handleSubmit}>
      <SimpleGrid cols={2}>
        <div className={styles['input-group']}>
          <label>Regional</label>
          <Select
            data={
              queryRegion
                ? [...getAreaByQuery(dataRegionals, region)]
                : [{ value: '', name: 'Semua Regional', label: 'Semua Regional' }, ...dataRegionals]
            }
            disabled={dataDetailUser?.regionalId !== '' || queryRegion}
            hideLabel
            icon="chevron"
            onChange={(e) => onRegionChanged(e)}
            value={region}
          />
        </div>
        <div className={styles['input-group']}>
          <label>Provinsi</label>
          <Select
            data={
              queryProvince
                ? [...getAreaByQuery(dataProvinces, queryProvince)]
                : [{ value: '', name: 'Semua Provinsi', label: 'Semua Provinsi' }, ...dataProvinces]
            }
            disabled={queryProvince}
            hideLabel
            icon="chevron"
            onChange={(e) => onProvinceChanged(e)}
            value={provinceId}
          />
        </div>
      </SimpleGrid>
      <SimpleGrid cols={2}>
        <div className={styles['input-group']}>
          <label>Kota/Kabupaten</label>
          <Select
            data={
              queryCity
                ? [...getAreaByQuery(dataCities, queryCity)]
                : [{ value: '', name: 'Semua Kota/Kabupaten', label: 'Semua Kota/Kabupaten' }, ...dataCities]
            }
            disabled={queryCity}
            hideLabel
            icon="chevron"
            onChange={(e) => onCityChanged(e)}
            value={cityId}
          />
        </div>
        <div className={styles['input-group']}>
          <label>Kecamatan</label>
          <Select
            data={
              queryDistrict
                ? [...getAreaByQuery(dataDistricts, queryDistrict)]
                : [{ value: '', name: 'Semua Kecamatan', label: 'Semua Kecamatan' }, ...dataDistricts]
            }
            disabled={queryDistrict}
            hideLabel
            icon="chevron"
            onChange={(e) => onDistrictChanged(e)}
            value={districtId}
          />
        </div>
      </SimpleGrid>
      <SimpleGrid cols={2}>
        <div className={styles['input-group']}>
          <label>Kelurahan</label>
          <Select
            data={
              queryVillage
                ? [...getAreaByQuery(dataVillages, queryVillage)]
                : [{ value: '', name: 'Semua Kelurahan', label: 'Semua Kelurahan' }, ...dataVillages]
            }
            disabled={queryVillage}
            hideLabel
            icon="chevron"
            onChange={(e) => onVillageChanged(e)}
            value={villageId}
          />
        </div>
      </SimpleGrid>
      <hr className={styles.separator} />
      <SimpleGrid cols={2}>
        <Field component={Text} inputProps={hargaJualMin} name="hargaJualMin" />
        <Field component={Text} inputProps={hargaJualMax} name="hargaJualMax" />
      </SimpleGrid>
      <hr className={styles.separator} style={{ margin: '2.5rem 0' }} />
      <div className={styles['form-action']}>
        <Button
          className={styles['form-btn']}
          disabled={submitting}
          onClick={() => navigate('/price?tab=subpangkalan')}
          outlined={true}
        >
          Kembali
        </Button>
        <Button
          className={styles['form-btn']}
          disabled={submitting || invalid}
          type="submit"
        >
          Simpan
        </Button>
      </div>
    </form>
  );
}

Component.propTypes = {
  change: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  invalid: PropTypes.bool.isRequired,
  pristine: PropTypes.bool.isRequired,
  submitting: PropTypes.bool.isRequired,
};

export default reduxForm({
  form: 'sub-user-product-prices',
  productGeneralMinPrice: 0,
  productGeneralMaxPrice: 0,
  initialValues: {
    region: '',
    provinceId: '',
    cityId: '',
    districtId: '',
    villageId: '',
    hargaJualMin: '',
    hargaJualMax: '',
  },
  validate(values, props) {
    return validate(values, props.productGeneralMaxPrice, props.productGeneralMinPrice);
  }
})(Component);
